<slide-navigation (itemNavigationClicked)="onItemNavigationClicked($event)" *ngIf="authenticated" >
</slide-navigation>

<div class="bz-loading" *ngIf="!authenticated ">
  <bz-loading></bz-loading>
</div>
